module.exports = __webpack_public_path__ + "img/startup.55bab2be.png";